// ─────────────────────────────────────────────────────────────────────────────
// Turf Talk launch-mode switch (SINGLE SOURCE OF TRUTH)
//
// The public "Request a Demo" front-door shell is TEMPORARY. This one flag
// controls the entire launch lifecycle. Nothing else should hard-code the
// prelaunch/live decision — always import from here.
//
//   REACT_APP_LAUNCH_MODE = "prelaunch"  → public front-door shell is shown,
//                                          interior stays invite-controlled.
//   REACT_APP_LAUNCH_MODE = "live"       → shell is bypassed, the subdomain
//                                          routes straight into the full working
//                                          Turf Talk app under the standard auth
//                                          model (unauth → /login).
//
// SAFE DEFAULT: anything missing/invalid/unknown falls back to "prelaunch"
// (closed), so the interior is never accidentally exposed.
//
// ── ONE-STEP CUTOVER TO LIVE (do only when Peter authorizes launch) ──────────
//   1. In /app/frontend/.env set:  REACT_APP_LAUNCH_MODE=live
//   2. Restart the frontend:       sudo supervisorctl restart frontend
//   (No code changes, no route renames, no data changes.)
//
// ── ONE-STEP ROLLBACK TO PRELAUNCH ───────────────────────────────────────────
//   1. In /app/frontend/.env set:  REACT_APP_LAUNCH_MODE=prelaunch (or remove it)
//   2. Restart the frontend:       sudo supervisorctl restart frontend
// ─────────────────────────────────────────────────────────────────────────────

const raw = (process.env.REACT_APP_LAUNCH_MODE || "").trim().toLowerCase();

export const LAUNCH_MODE = raw === "live" ? "live" : "prelaunch";
export const IS_PRELAUNCH = LAUNCH_MODE !== "live";
export const IS_LIVE = LAUNCH_MODE === "live";
